<template>
  <div class="page">
    <div class="nav1">
      员工绑定 
    </div>
    <div class="form">
   
      <van-form @submit="onSubmit" aria-autocomplete="false">
        <van-field required v-model="form.name" name="name" label="姓名" placeholder="请输入被姓名"
          :rules="[{ required: true, message: '' }]" />
        <van-field required v-model="form.employId" name="employId" label="工号" placeholder="请输入工号"
          :rules="[{ required: true, message: '' }]" />
        <van-field required v-model="form.mobile" name="mobile" label="手机号" placeholder="请输入手机号" type="tel"
          :rules="[{ required: true, message: '' }]" />

        <!-- <van-field required v-model="form.sms" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button size="small" type="primary">发送验证码</van-button>
          </template>
        </van-field> -->


        <div style="margin: 16px;">
          <van-button :loading="isLoading" round block type="info" native-type="submit">绑定
          </van-button>
        </div>
      </van-form>


    </div>
  </div>
</template>

<script>
import { Form } from 'vant'
export default {
  data() {
    return {
      isLoading: false,
      form: {
        name: '',
        mobile: '',
        employId: '',
        vaild: '',
      }
    }
  },
  components: {
    'van-form': Form,
  },
  mounted() {

  },
  methods: {
    onLoad() {
    },

    onSubmit(e) {
      this.isLoading = true;
      this.axios
        .post('employee/bind', { ...e, vaild: this.$route.query.t })
        .then(res => {
          if (res.errorCode == 0) {
            this.isLoading = false
            console.log(res.data)
            // 跳转到下一步
            this.$dialog.alert({
              title: '系统提示',
              message: '绑定成功'
            }).then(res => {
              this.$router.replace({
                path: '/index'
              })
            })
          } else {
            this.isLoading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })
    }
  }
}
</script>

<style scoped lang="less">
.page {
  min-height: 100vh;
  background: #3a88f2;

  .nav1 {
    height: 80px;
    color: #fff;
    line-height: 80px;
    text-indent: 10px;
    font-size: 24px;

    span {
      color: #2765b7;
      font-size: 20px;
    }
  }

  .form {
    background: #f8f8f8;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding-top: 10px;
    box-sizing: border-box;
    height: calc(100vh - 80px);
    width: 100%;

    .sub-title {
      margin: 0;
      padding: 16px 16px 16px;
      color: #333333;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;
      font-weight: bold;
    }

    .rule {
      margin: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        color: #63a1f5;
      }
    }
  }

  .block {
    background: #FFF;
    width: 80%;
    margin: 0 auto;
    justify-content: center;
    // padding: 20px 24px;
    margin-top: 30px;
    box-sizing: border-box;

    p {
      margin: 0;
      padding: 0;
      margin-bottom: 12px;
    }

    span {
      line-height: 25px;
      font-size: 13px;
      text-indent: 20px;
    }
  }
}
</style>
